import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { RahkaranSetting } from "../rahkaran.model";
import { take, takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-rahkaran-setting",
  templateUrl: "./rahkaran-setting.component.html",
  styleUrls: ["./rahkaran-setting.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RahkaranSettingComponent extends BaseFormComponent<RahkaranSetting> {
  dataList: RahkaranSetting[] = [];
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, __id: FormContainerModel, _tabsservice: TabularService) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }

  async ngOnInit() {
    this.apiName = "RahkaranSetting";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Pages.PageMenu.RahkaranSetting");
    const list = (await this.httpCommonService.get(this.apiName).pipe(take(1)).toPromise()) as any[];
    if (list.length) this.currentrow = list[0];
    super.ngOnInit();
  }

  setColumnAttribute() {
    super.setColumnAttribute();
    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null)));
    this.cd.markForCheck();
  }

  addControl() {
    if (this.formGroup) {
      this.setValue("BankAccountId", this.model.BankId);
      this.setValue("Cash", this.model.CashId);
      this.setValue("AccountingOperation", this.model.AccountingOperationId);
      this.setValue("CashFlowFactort", this.model.CashFlowFactorId);
    }
  }
  GetProductInfo() {
    this.httpCommonService
      .getList("Rahkaran/GetRahkaranInfo")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data) => {
          console.log(data);
        },
        (error) => console.log(error)
      );
  }
}
